import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import * as React from "react";
import { useMutation } from "react-query";
import { useHistory } from "react-router-dom";
import { ApiResultModel } from "../../models/common.model";
import {
  GetProductsCategoryRequest,
  GetProductsCategoryResponse,
} from "../models/store.model";
import { GetProductCategory } from "../service/store.service";
import Header from "./header";
import { useEffect, useState } from "react";
import { PARENT_CATEGORY_ID } from "../../config/cacheKey";
import CategorySkeleton from "./categorySkeleton";

export default function ProductCategory() {
  const history = useHistory<{
    parentCategoryId: number;
    title: string;
  }>();
  useEffect(() => {
    const productsRequest = {} as GetProductsCategoryRequest;
    productsRequest.parentCategoryId = undefined;
    getProductCategory(productsRequest);
  }, []);

  const [data, setData] = useState<GetProductsCategoryResponse>();
  const { mutate: getProductCategory, isLoading } = useMutation(
    GetProductCategory,
    {
      onSuccess: (result: ApiResultModel<GetProductsCategoryResponse>) => {
        if (result) {
          setData(result.data);
        }
      },
    }
  );

  function selectProductCategoury(id: number, title: string) {
    sessionStorage.setItem(PARENT_CATEGORY_ID, String(id));
    history.push({
      pathname: `/products/productCategory1/productCategoryCard`,
      state: {
        parentCategoryId: id,
        title: title,
      },
    });
  }

  return (
    <Box sx={{ width: "100%" }}>
      <Grid container>
        <Grid item xs={12}>
          <Header search={true} category={false} parentCategoryId={undefined} />
        </Grid>
        {!isLoading ? (
          <Grid
            container
            xs={12}
            spacing={4}
            style={{
              backgroundColor: "#F5F5F5",
              marginTop: "18px",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {data?.items.map((item: any) => (
              <Grid item xs={4} md={3} lg={2}>
                <div
                  onClick={() => selectProductCategoury(item.id, item.title)}
                  className="cursorPointer"
                >
                  <img
                    style={{ width: "100%", height: "85%" }}
                    className="classCenter objectFit"
                    src={`data:image/png;base64,${item.imageData}`}
                    alt="طرح "
                  />
                  <span
                    style={{
                      textAlign: "center",
                      display: "grid",
                      fontSize: "18px",
                      fontWeight: "bold",
                      color: "#0D47A1",
                      marginBottom: "20px",
                      marginTop: "20px",
                    }}
                  >
                    {item.title}
                  </span>
                </div>
              </Grid>
            ))}
          </Grid>
        ) : (
          <CategorySkeleton child={false} />
        )}
      </Grid>
    </Box>
  );
}
